import { render, staticRenderFns } from "./ComprehensiveCover.vue?vue&type=template&id=57151744&scoped=true"
import script from "./ComprehensiveCover.vue?vue&type=script&lang=js"
export * from "./ComprehensiveCover.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveCover.vue?vue&type=style&index=0&id=57151744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57151744",
  null
  
)

export default component.exports